import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  carsSuccess: ['data', 'ids'],
  carCheckRequest: ['vin', 'epts'],
  carAddRequest: ['id', 'data'],
  carUpdateRequest: ['data'],
  carDeleteRequest: ['id'],
  carSuccess: ['data'],
  carCheckSuccess: ['data'],
  carFailure: ['error'],
});

export const CarsTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  ids: [],
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

export const carsSuccess = (state, {data, ids}) =>
  state.merge({fetching: false, error: null, data, ids: ids ? ids : []});

// we've successfully ...
export const success = (state, {data}) => {
  let cars = {...state.data};
  delete cars.new;
  cars[data.id] = data;
  let ids = [...state.ids];
  if (data.id && !data.vin) {
    delete cars[data.id];
    ids.slice(state.ids.indexOf(data.id), 1);
  }
  if (ids.indexOf(data.id) < 0) {
    ids.push(data.id);
  }
  return state.merge({fetching: false, error: null, data: cars, ids});
}

export const checkSuccess = (state, {data}) => {
  let cars = {...state.data};
  cars.new = data;
  return state.merge({fetching: false, error: null, data: cars});
}

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CARS_SUCCESS]: carsSuccess,
  [Types.CAR_CHECK_REQUEST]: request,
  [Types.CAR_ADD_REQUEST]: request,
  [Types.CAR_UPDATE_REQUEST]: request,
  [Types.CAR_DELETE_REQUEST]: request,
  [Types.CAR_SUCCESS]: success,
  [Types.CAR_CHECK_SUCCESS]: checkSuccess,
  [Types.CAR_FAILURE]: failure,
});

/* ------------- Selectors ------------- */
export const CarsSelectors = {
  getCars: state => {
    const {ids, data} = state.cars;
    if (ids && ids.length && ids.length > 0) {
      const cars = ids.map(id => data[id]);
      return cars;
    }
    return [];
  }
}